// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"48":"result-page","79":"processing-static-page","185":"widget-page","285":"redirect-page"}[chunkId] || chunkId) + "." + {"48":"fac3778d","79":"1a6ef107","185":"6f5e0be1","200":"3c3ef9f1","285":"4970d98b","974":"75e01a3f"}[chunkId] + ".css";
};